
import {NEW_JOB_LIST_REQUEST, NEW_JOB_LIST_SUCCESS,NEW_JOB_LIST_FAIL} from "../constants/AuthConstant";

const axios = require("axios");

export const NewJobAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: NEW_JOB_LIST_REQUEST,
        payload: true,
      });
    
      let OPTION = {

        url: `${process.env.REACT_APP_API_PATH}/ebench/get_posted_jobs_by_candidate_skills`,
        // ?candidateId=${data.candidateId}&pageNumber=0&pageSize=10&filter=${data.isChecked}
        data: data,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: NEW_JOB_LIST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: NEW_JOB_LIST_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  